import { modifier } from 'ember-modifier';

export default modifier(
  function onScrollEndTop(element, [action]) {
    // Add 50px to prevent the action failing when the height of the window is smaller than the scrollHeight
    let handler = function () {
      if (
        element.scrollTop <=
        -(element.scrollHeight - element.offsetHeight) + 50
      ) {
        action?.();
      }
    };

    element.addEventListener('scroll', handler);

    // Prevents scroll being pinned to the top and automatically loading all data
    element.style.overflowAnchor = 'none';

    return () => {
      element.removeEventListener('scroll', handler);
    };
  },
  { eager: false }
);
